export const GoogleMapApiConfig = 'AIzaSyA5-rpCcym4eD_eYB-wR8EbfG8LBoW5ypw';